module.exports = "/_next/static/images/c8f1886e4ee8fae7ea201fc6a8d9177d-nubanker-tpm@1x.jpg";